import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-right",
  "use": "icon-right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-right\"><defs><style type=\"text/css\"></style></defs><path d=\"M684.569334 450.069509 684.436304 450.202539 339.429643 105.196901 277.56669 167.060877 622.572328 512.066515 277.69972 856.939123 339.563696 918.803099 684.436304 573.930491 746.299257 512.066515 746.43331 511.933485Z\" p-id=\"1888\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol